class HomeSliderController {
  constructor (AppConfig) {
    'ngInject'
    this.slides = AppConfig.pages.home.slides
  }
}

export default HomeSliderController



// WEBPACK FOOTER //
// ./src/app/pages/home/slider/home-slider.controller.js